// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SmartTextareaInput":"bfs_a bhe_vb bhe_vp bhe_xf bhe_vh"};